<template>
  <hm-content title="">
  <div class="flex act-container">
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <div class="ruleForm_title mb20">
            1.规则基本信息
          </div>
          <el-form-item label="规则名称" prop="groupName">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.groupName"
              placeholder="请输入规则名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="规则分类" prop="typeId">
            <el-select
              size="small"
              clearable
              placeholder="请选择规则分类"
              v-model="ruleForm.typeId"
              class="mr20"
            >
              <el-option
                :label="v.typeName"
                :value="v.id"
                v-for="(v, i) in typeNameListAll"
                :key="i"
              ></el-option>
            </el-select>
            <el-button size="small" @click="typeNameListEdit" type="primary"
              >管理分类</el-button
            >
          </el-form-item>
          <div class="flex flex-between">
            <div class="width45">
              <div class="ruleForm_title mb20">
                2.命中第三方词库
              </div>
              <div class="flex flex-between item-center">
                <el-button size="small" @click="addWordTypeList('tx')" type="primary"
                  >+添加腾讯接口词返回词</el-button
                >
                <div class="flex flex-end">
                  <div class="success pointer" @click="outputExcel">导出模版<span class="delete-icon hmicon icon-daochu ml5"></span></div>
                  <div class="danger pointer ml20 open-file">导入数据<span class="delete-icon hmicon icon-daoru ml5"></span>
                    <input
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </div>
                </div>
              </div>
              <div class="table-wrapper mt20">
                <el-table
                  :data="ruleForm.txWordList"
                  style="width: 100%"
                  stripe
                  border
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="接口返回商品词"
                    prop="word"
                  >
                  </el-table-column>
                  <el-table-column label="操作" header-align="center" align="center" width="150px">
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <el-tooltip class="item" content="编辑" placement="top">
                          <div class="pointer mr10 no-bg" @click="editWord(scope.row,'tx')">
                            <span class="hmicon icon-bianji blue"></span>
                          </div>
                        </el-tooltip>
                        <el-tooltip
                          class="item"
                          content="删除"
                          placement="top"
                          style="color: #E50065"
                        >
                          <div class="pointer mr10 no-bg" @click="removeWord(scope.row,'tx',scope.$index)">
                            <span class="hmicon icon-shanchu blue"></span>
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="hm-pagination mb20">
                  <el-pagination
                    background
                    :total="groupListTotal"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                  ></el-pagination>
                </div> -->
              </div>
            </div>
            <div class="width45">
              <div class="ruleForm_title mb20">
                3.命中自定义词
              </div>
              <div class="flex flex-between item-center">
                <el-button size="small" @click="addWordTypeList('custom')" type="primary"
                  >+添加自定义词</el-button
                >
                <div class="flex flex-end">
                  <div class="success pointer" @click="outputExcel2">导出模版<span class="delete-icon hmicon icon-daochu ml5"></span></div>
                  <div class="danger pointer ml20 open-file">导入数据<span class="delete-icon hmicon icon-daoru ml5"></span>
                    <input
                      type="file"
                      @change="importf2"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </div>
                </div>
              </div>
              <div class="table-wrapper mt20">
                <el-table
                  :data="ruleForm.customWordList"
                  style="width: 100%"
                  stripe
                  border
                  size="small"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="命中词"
                    prop="word"
                  >
                  </el-table-column>
                  <el-table-column label="操作" header-align="center" align="center" width="150px">
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <el-tooltip class="item" content="编辑" placement="top">
                          <div class="pointer mr10 no-bg" @click="editWord(scope.row,'custom')">
                            <span class="hmicon icon-bianji blue"></span>
                          </div>
                        </el-tooltip>
                        <el-tooltip
                          class="item"
                          content="删除"
                          placement="top"
                          style="color: #E50065"
                        >
                          <div class="pointer mr10 no-bg" @click="removeWord(scope.row,'custom',scope.$index)">
                            <span class="hmicon icon-shanchu blue"></span>
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="hm-pagination mb20">
                  <el-pagination
                    background
                    :total="groupListTotal"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                  ></el-pagination>
                </div> -->
              </div>
            </div>
          </div>
          <div class="flex flex-center mt20">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog
        title="词库分类"
        :visible.sync="dialogVisible"
        width="800px"
        @close="saveTypeNameList"
      >
      <div slot="title" class="wordList">
        <span>词库分类</span>
      </div>
      <div class="content">
        <div class="flex item-center">
          添加分类
          <el-input
            size="small"
            clearable
            class="ml20 mr20 ipt"
            v-model.trim="typeName"
            placeholder="请输入词库分类"
            maxlength="30"
          ></el-input>
          <el-button
            type="primary"
            @click="addTypeName"
            size="mini"
            icon="hmicon icon-hao"
            circle
          ></el-button>
        </div>
        <div class="table-wrapper mt20">
          <el-table
            :data="typeNameList"
            style="width: 100%"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPageTypeNameList - 1) * pageSizeTypeNameList + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="分类名称"
              prop="typeName"
            >
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="150px">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip
                    class="item"
                    content="删除"
                    placement="top"
                    style="color: #E50065"
                  >
                    <button class="pointer mr10 no-bg" @click="removeTypeNameList(scope.row)">
                      <span class="hmicon icon-shanchu blue"></span>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination mb20">
            <el-pagination
              background
              :total="typeNameListTotal"
              @current-change="pagingTypeNameList"
              @size-change="handleSizeChangeTypeNameList"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageTypeNameList"
            ></el-pagination>
          </div>
        </div>
        <div slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="saveTypeNameList" type="primary" size="small">确定</el-button>
          <el-button @click="saveTypeNameList" type="info" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
        title="词库分类"
        :visible.sync="dialogVisibleWord"
        width="500px"
        @close="closeWord"
      >
      <div slot="title" class="wordList">
        <span>{{wordTypeTitle}}</span>
      </div>
      <div class="content">
        {{wordTypeTitle}}
        <el-input
          size="small"
          clearable
          class="ml20 mr20 ipt"
          v-model.trim="word"
          :placeholder="'请输入' + wordTypeTitle"
          style="width:200px"
        ></el-input>
      </div>  
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveWord" type="primary" size="small">确定</el-button>
        <el-button @click="closeWord" type="info" size="small">取消</el-button>
      </div>
    </el-dialog>  
  </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { arrayUnique2 } from "@/utils/utils";
import HmForm from "@/components/HmForm";
import { mapGetters } from "vuex";
import * as XLSX from 'xlsx/xlsx'
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {  HmForm },
  data() {
    return {
      groupList: [],
      groupListTotal: 0,
      ruleForm:{
        groupName: "",
        typeId: "",
        txWordList:[],
        customWordList:[],
      },
      rules:{
        typeId: [
          { required: true, message: "请选择规则分类", trigger: "change" },
        ],
        groupName: [
          { required: true, message: "请输入规则名称", trigger: "blur" },          
        ],
      },
      typeNameList:[],
      typeNameListAll:[],
      currentPage: 1,
      pageSize: 10,
      currentPageTypeNameList: 1,
      pageSizeTypeNameList: 10,
      typeNameListTotal: 0,
      dialogVisible: false,
      typeName: "",
      wordType: "",
      dialogVisibleWord: false,
      wordTypeTitle: "",
      groupId: "",
      word: "",
      row: {},
      wordTypeSave: "",
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryPageListAll();    
  },
  computed: mapGetters(["storeStyle", "shopList"]),
  methods: {
    //提交按钮点击新增一条规则
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store
            .dispatch("sysDictionaryGroupInfoAdd", params)
            .then((res) => {
              if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            this.$router.back(-1);
          }
        })
      }
     })
    },
    //管理分类按钮点击
    typeNameListEdit(){
      this.queryPageList();
      this.dialogVisible = true;
    },
    //添加分类
    async addTypeName(){
      if(!this.typeName){
        this.$message({
          message: "请输入词库分类",
          type: "warning",
        });
        return;
      }
      let params = {
        typeName: this.typeName,
      };      
      const {code} = await this.$store.dispatch("sysDictionaryTypeInfoAdd",
        params
      );
      if(code === "0"){
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.typeName = "";
        this.queryPageList();
      }
    },
    //查询分类列表
    async queryPageList(){
      let params = {
        pageSize: this.pageSizeTypeNameList,
        pageNo: this.currentPageTypeNameList,
      }
      const { result } = await this.$store.dispatch("sysDictionaryTypeInfoQueryPageList",params);
      if(result){
        const { records, total } = result;
        this.typeNameList = records;
        this.typeNameListTotal = total;
      }
    },
    //查询分类总列表
    async queryPageListAll(){
      let params = {
        pageSize: 9999,
        pageNo: 1,
      }
      const { result } = await this.$store.dispatch("sysDictionaryTypeInfoQueryPageList",params);
      if(result){
        const { records } = result;
        this.typeNameListAll = records;
      }
    },
    //分类展示多少个
    handleSizeChangeTypeNameList(size) {
      this.currentPageTypeNameList = 1;
      this.pageSizeTypeNameList = size;
      this.queryPageList();
    },
    //分类翻页
    pagingTypeNameList(page) {
      this.currentPageTypeNameList = page;
      this.queryPageList();
    },
    //删除分类
    async removeTypeNameList(row){
      const result = await this.$confirm("删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
          let params = {
            id: row.id,
          };      
          const { code } = await this.$store.dispatch("sysDictionaryTypeInfoRemoveByModel",
            params
          );
          if(code === "0"){
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.queryPageList();
          }
      }
    },
    //分类确定取消按钮点击
    saveTypeNameList(){
      this.queryPageListAll();
      this.dialogVisible = false;
    },
    //词库分类弹窗点击确定
    async saveWord(){
      if(!this.word){
        this.$message({
          message: "请输入" + this.wordTypeTitle ,
          type: "warning"
        });
        return;
      }
      console.log("this.wordTypeSave:",this.wordTypeSave);
      console.log("this.wordType:",this.wordType);
      if(this.wordTypeSave === 'add'){
        if(this.wordType==='tx'){
          this.ruleForm.txWordList.push({
            word: this.word
          })
          this.ruleForm.txWordList = arrayUnique2(this.ruleForm.txWordList,"word");
          console.log("this.ruleForm.txWordList:",this.ruleForm.txWordList);
        }else if(this.wordType==='custom'){
          this.ruleForm.customWordList.push({
            word: this.word
          })
          this.ruleForm.customWordList = arrayUnique2(this.ruleForm.customWordList,"word");
        }
      }else if(this.wordTypeSave === 'edit'){
        this.row.word = this.word;
      }
      this.dialogVisibleWord = false;
    },
    //词库分类弹窗点击取消
    closeWord(){
      this.dialogVisibleWord = false;
    },
    //添加腾讯接口词返回词和添加自定义词按钮点击
    addWordTypeList(wordType){
      this.word = "";  
      this.wordTypeSave = "add";
      this.wordType = wordType;
      if(wordType==='tx'){
        this.wordTypeTitle = "添加腾讯接口词"
      }else{
        this.wordTypeTitle = "添加自定义词"
      }
      this.dialogVisibleWord = true;
    },
    //修改腾讯接口词和自定义词
    editWord(row,wordType){
      this.wordTypeSave = "edit";
      this.row = row;
      this.word = this.row.word;
      this.wordType = wordType;
      if(wordType==='tx'){
        this.wordTypeTitle = "修改腾讯接口词"
      }else{
        this.wordTypeTitle = "修改自定义词"
      }      
      this.dialogVisibleWord = true;
    },
    //删除腾讯接口词和自定义词
    async removeWord(row,wordType,index){
      if(wordType==='tx'){
        this.ruleForm.txWordList.splice(index, 1);
      }else if(wordType==='custom'){
        this.ruleForm.customWordList.splice(index, 1);
      }
    },
    //导出腾讯接口词模板
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "接口返回商品词",
        ];
        exportJsonToExcel(
            tHeader,
            [[]],
            "腾讯接口词模板"
        );
      });
    },
    //导出自定义词模板
    outputExcel2() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "自定义词",
        ];
        exportJsonToExcel(
            tHeader,
            [[]],
            "自定义词模板"
        );
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:",result);
        const formatResult = [];
        result.forEach(v => {
          formatResult.push({
            word: v[0],
          });
        });
        that.ruleForm.txWordList.push(...formatResult);
        that.ruleForm.txWordList = arrayUnique2(that.ruleForm.txWordList,"word");
        console.log("that.ruleForm.txWordList:",that.ruleForm.txWordList);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel
    importf2(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:",result);
        const formatResult = [];
        result.forEach(v => {
          formatResult.push({
            word: v[0],
          });
        });
        that.ruleForm.customWordList.push(...formatResult);
        that.ruleForm.customWordList = arrayUnique2(that.ruleForm.customWordList,"word");
        console.log("that.ruleForm.customWordList:",that.ruleForm.customWordList);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
  },
};
</script>

<style scoped lang="scss">
.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 100%;
    flex-shrink: 0;
    .ruleForm_title{
      font-size: 16px;
      font-weight: 600;
      color: #222222;
      &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
    }
  }
}
.width45{
  width: 45%;
}

.ml5{
  margin-left: 5px;
}
/deep/ .el-pagination__editor.el-input{
  width: 50px !important;
}
.wordList{
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  line-height: 20px;
  border-bottom: solid 1px #DDDDDD;
  padding-bottom: 18px;  
}
</style>
